import { BoxItem } from '../common/styled/BoxItem'
import React from 'react'
import ViewBtn from '../common/ViewBtn'
import styled from 'styled-components';

const NFTBoxItemStyle = styled(BoxItem)`
  .img-panel {
    background-color:#ccc;
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
    height:250px;
    width:100%;
    >img {
      width: 100%;
      object-fit: cover;
    }
  }
  .cont {
    padding:25px 20px;
    .title {
      color:#2A2D35;
      padding-bottom: 20px;
      font-size:28px;
      font-weight: 500;
    }
    >p {
      color:#666;
      font-size:18px;
      line-height:26px;
    }
  }
  .go-box {
    margin: 30px auto;
    width: 70%;
    display: flex;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .img-panel {
      height: 200px;
    }
  }
`;

export default function NFTBoxItem(props) {
  return (
    <NFTBoxItemStyle>
      <div className="img-panel">
        <img src={props.img} alt=""/>
      </div>
      <div className="cont">
        <div className="title">{props.title}</div>
        <p>{props.desc}</p>
      </div>
      <div className="go-box">
        <ViewBtn href={props.url}></ViewBtn>
      </div>
    </NFTBoxItemStyle>
  )
}

